import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  class: "sidebar-wrapper"
}
const _hoisted_2 = {
  ref: "scrollElRef",
  id: "kt_aside_menu_scroll",
  class: "scroll-y my-5 mx-3",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "true",
  "data-kt-scroll-dependencies": "#kt_aside_logo",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "5px",
  "data-kt-scroll-wrappers": "#kt_aside_menu",
  "data-kt-scroll-save-state": "true"
}
const _hoisted_3 = {
  id: "#kt_aside_menu",
  class: "menu menu-column menu-rounded menu-sub-indention",
  "data-kt-menu": "true",
  "data-kt-menu-expand": "false"
}
const _hoisted_4 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_5 = { class: "menu-content pt-8 pb-2" }
const _hoisted_6 = { class: "menu-section text-muted text-uppercase fs-7" }
const _hoisted_7 = { class: "menu-link" }
const _hoisted_8 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_9 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_10 = { class: "menu-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_12 = { class: "menu-link" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_14 = { class: "menu-title" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_19 = { class: "menu-title" }
const _hoisted_20 = ["href", "target"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_24 = ["href", "onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = ["href", "target"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_29 = { class: "menu-title" }
const _hoisted_30 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_31 = ["href", "onClick"]
const _hoisted_32 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_33 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_34 = { class: "menu-title" }
const _hoisted_35 = ["href", "target"]
const _hoisted_36 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_37 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_38 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuConfig, (item, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (item.heading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.heading), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                (menuItem.pages && menuItem.pages.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"]),
                      "data-kt-menu-sub": "accordion",
                      "data-kt-menu-trigger": "click"
                    }, [
                      _createElementVNode("span", _hoisted_7, [
                        (menuItem.svgIcon || menuItem.fontIcon)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                              (_ctx.asideMenuIcons === 'font')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                  }, null, 2))
                                : (_ctx.asideMenuIcons === 'svg')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                      _createVNode(_component_inline_svg, {
                                        src: 'media/icons/' + menuItem.svgIcon
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(menuItem.heading), 1),
                        _hoisted_11
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.pages, (item2, k) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                            (item2.pages && item2.pages.length > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"]),
                                  "data-kt-menu-sub": "accordion",
                                  "data-kt-menu-trigger": "click"
                                }, [
                                  _createElementVNode("span", _hoisted_12, [
                                    _hoisted_13,
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(item2.heading), 1),
                                    _hoisted_15
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"])
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.pages, (item3, k) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                        (item3.heading)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                              (_ctx.isCurrentSystem(item.belong))
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 0,
                                                    to: item3.route,
                                                    custom: ""
                                                  }, {
                                                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                                      _createElementVNode("a", {
                                                        class: _normalizeClass(["menu-link", [
                                isActive && 'active',
                                isExactActive && 'active',
                                _ctx.isLinkActive(item3.route) && 'active',
                              ]]),
                                                        href: href,
                                                        onClick: navigate
                                                      }, [
                                                        _hoisted_18,
                                                        _createElementVNode("span", _hoisted_19, _toDisplayString(item3.heading), 1)
                                                      ], 10, _hoisted_17)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"]))
                                                : (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    class: "menu-link",
                                                    href: 
                              (item.base_url ? item.base_url + '/#' : '') +
                              item3.route
                            ,
                                                    target: 
                              item3.route.indexOf('http') == 0
                                ? '_blank'
                                : '_self'
                            
                                                  }, [
                                                    _hoisted_21,
                                                    _createElementVNode("span", _hoisted_22, _toDisplayString(item3.heading), 1)
                                                  ], 8, _hoisted_20))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ], 2)
                                ], 2))
                              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  (_ctx.isCurrentSystem(item.belong))
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: item2.route,
                                        custom: ""
                                      }, {
                                        default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                          _createElementVNode("a", {
                                            class: _normalizeClass([[
                          isActive && 'active',
                          isExactActive && 'active',
                          _ctx.isLinkActive(item2.route) && 'active',
                        ], "menu-link"]),
                                            href: href,
                                            onClick: navigate
                                          }, [
                                            _hoisted_25,
                                            _createElementVNode("span", _hoisted_26, _toDisplayString(item2.heading), 1)
                                          ], 10, _hoisted_24)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: "menu-link",
                                        href: 
                        (item.base_url ? item.base_url + '/#' : '') +
                        item2.route
                      ,
                                        target: 
                        item2.route.indexOf('http') == 0 ? '_blank' : '_self'
                      
                                      }, [
                                        _hoisted_28,
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(item2.heading), 1)
                                      ], 8, _hoisted_27))
                                ]))
                          ], 64))
                        }), 128))
                      ], 2)
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (_ctx.isCurrentSystem(item.belong))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: menuItem.route,
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                              _createElementVNode("a", {
                                class: _normalizeClass([[
                      isActive && 'active',
                      isExactActive && 'active',
                      _ctx.isLinkActive(menuItem.route) && 'active',
                    ], "menu-link"]),
                                href: href,
                                onClick: navigate
                              }, [
                                (menuItem.svgIcon || menuItem.fontIcon)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                      (_ctx.asideMenuIcons === 'font')
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                          }, null, 2))
                                        : (_ctx.asideMenuIcons === 'svg')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                              _createVNode(_component_inline_svg, {
                                                src: 'media/icons/' + menuItem.svgIcon
                                              }, null, 8, ["src"])
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(menuItem.heading), 1)
                              ], 10, _hoisted_31)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "menu-link",
                            href: 
                    (item.base_url ? item.base_url + '/#' : '') + menuItem.route
                  ,
                            target: 
                    menuItem.route.indexOf('http') == 0 ? '_blank' : '_self'
                  
                          }, [
                            (menuItem.svgIcon || menuItem.fontIcon)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                  (_ctx.asideMenuIcons === 'font')
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                      }, null, 2))
                                    : (_ctx.asideMenuIcons === 'svg')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                          _createVNode(_component_inline_svg, {
                                            src: 'media/icons/' + menuItem.svgIcon
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(menuItem.heading), 1)
                          ], 8, _hoisted_35))
                    ]))
              ], 64))
            }), 128))
          ], 64))
        }), 128))
      ])
    ], 512)
  ]))
}